import { OneTrustRemoteKey, OneTrustRemoteKeys } from 'types/oneTrust';

/**
 * OneTrust resolves a press as `event.code || event.keyCode`, so `code` wins
 * wherever the browser sets it. Chromium sets it for the standard keys on TV
 * as much as in a desktop browser, and leaves it empty for vendor codes like
 * Tizen's 10009 — so every platform needs these names alongside its own
 * numeric entries.
 *
 * `Backspace` is deliberately absent: it belongs to the platforms that treat
 * keyCode 8 as their back key, and is declared alongside their key map.
 */
export const ONE_TRUST_NAV_KEYS: OneTrustRemoteKeys = {
  ArrowUp: 'UP',
  ArrowDown: 'DOWN',
  ArrowLeft: 'LEFT',
  ArrowRight: 'RIGHT',
  Enter: 'OK',
};

/** Our platform key maps all share this vocabulary for the keys OneTrust uses */
const ONE_TRUST_KEY_BY_APP_KEY: Record<string, OneTrustRemoteKey> = {
  Up: 'UP',
  Down: 'DOWN',
  Left: 'LEFT',
  Right: 'RIGHT',
  Enter: 'OK',
  Back: 'BACK',
};

/**
 * Restates a platform's own key map in OneTrust's vocabulary, dropping every
 * key the SDK has no use for. Each platform therefore hands OneTrust the codes
 * its own remote sends and nothing else.
 */
export const toOneTrustKeys = (
  keyMapping: Record<number, string>,
): OneTrustRemoteKeys => {
  const remoteKeys: OneTrustRemoteKeys = {};

  Object.keys(keyMapping).forEach(keyCode => {
    const appKey = keyMapping[Number(keyCode)];
    const remoteKey = appKey ? ONE_TRUST_KEY_BY_APP_KEY[appKey] : undefined;

    if (remoteKey) remoteKeys[keyCode] = remoteKey;
  });

  return remoteKeys;
};
